import { GridDensity, useGridApiRef } from '@mui/x-data-grid-premium'
import { useEntitiesFromSearch } from 'api/search'
import { useLayoutContext } from 'context/LayoutProvider/LayoutProvider'
import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import GlobalDataGrid from 'components/DataGrid/GlobalDataGrid'
import { defaultFilterModel, defaultSortModel } from './defaultModels'
import OptimizationToolbar from './OptimizationToolbar'
import renderOptimizationsColumns from './grid/renderOptimizationsColumns'

const OptimizationsPage = () => {
  const { pinned } = useLayoutContext()
  const navigate = useNavigate()
  const apiRef = useGridApiRef()
  const { optimizations: allOpts, organizations } = useEntitiesFromSearch()
  const currentMonth = dayjs().format('YYYY-MM')
  const [monthFilter, setMonthlyFilter] = useState(currentMonth ?? '')
  const [_density, setDensity] = useState<GridDensity>(() => {
    const saved = localStorage.getItem('optDensityModel') as GridDensity | null
    return saved ?? 'standard'
  })
  const optimizations = React.useMemo(() => {
    if (!allOpts || !organizations) return []

    return (
      allOpts?.map(o => ({
        ...o,
        organization: organizations.find(org => org.PK === o?.PK) || null,
        isParent: true,
        rowId: o.SK,
      })) || []
    )
  }, [allOpts, organizations])
  const [monthlyOpts, setMonthlyOpts] = useState(optimizations ?? [])
  const changeMonthlyFilter = (month: string) => {
    setMonthlyFilter(month)

    const filtered = optimizations?.filter(opt => {
      if (!opt?.createdAt) return false
      return dayjs(opt.createdAt).format('YYYY-MM') === month
    })

    setMonthlyOpts(filtered)
  }
  const changeDensity = (newDensity: GridDensity) => {
    setDensity(newDensity)
  }
  const clearFilters = () => {
    setMonthlyFilter(currentMonth ?? '')
  }
  const handleRowClick = (orgPK: string) => {
    navigate(`/organizations/${orgPK}/details`)
  }
  const columns = renderOptimizationsColumns(handleRowClick) ?? []
  const defaultColumnWidths = Object.fromEntries(
    columns
      .filter(col => typeof col.width === 'number') // only include columns that define a width
      .map(col => [col.field, col.width])
  )
  return (
    <GlobalDataGrid
      columns={columns}
      rows={monthlyOpts}
      apiRef={apiRef}
      context={'opt'}
      defaultFilterModel={defaultFilterModel}
      defaultVisibilityModel={{}}
      defaultSortModel={defaultSortModel}
      defaultGridDensity={'standard'}
      defaultColumnWidths={defaultColumnWidths}
      monthFilter={monthFilter}
      toolbarComponent={OptimizationToolbar}
      onChangeDensity={changeDensity}
      onChangeMonth={changeMonthlyFilter}
      onClearFilters={clearFilters}
      treeData={false}
      gridContainerSx={{
        position: 'relative',
        pt: pinned ? '60px' : 0.8,
        transition: 'all 0.3s ease', // or .5s, etc.
        width: '100%',
        height: '100%',
        overflowX: 'auto',
        overflowY: 'hidden',
        zIndex: 1150,
      }}
    />
  )
}

export default OptimizationsPage
